import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Navigation from "./shared/Navigation.js";
import { useOktaAuth } from '@okta/okta-react';
import { Alert } from 'react-bootstrap';
import { trackPageView } from '../services/googleServices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AndroidAppFlavours from './shared/AndroidAppFlavours';

const Dashboard = () => {
  const location = useLocation();
  const { authState } = useOktaAuth();

  // Check if running inside the native Android wrapper or if the Pro flag is set
  const isMobileApp = /HealthDash/i.test(navigator.userAgent) || window.PCD_PRO_ACTIVE;

  const mobileAppLink = authState?.isAuthenticated
    ? "https://play.google.com/store/apps/details?id=com.linardsl.libhacontimig.hm.finalPro"
    : "https://play.google.com/store/apps/details?id=com.linardsl.libhacontimig.hm.final";

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
      <>
        <Navigation/>
        <header className="justify-content-center py-2 bg-warning text-center text-white shadow-sm mt-5">
          <div className="container">
            <div className="row">
              <div className="col">
                <h1 className="font-weight-bold">HolimaX Product Ecosystem | {authState?.isAuthenticated ? <>Personalized Cloud Dashboard (<abbr title="Personalized Cloud Dashboard">PCD</abbr>)</> : <>The Cloud Dashboard (<abbr title="Cloud Dashboard">CD</abbr>)</>}</h1>
                <p>Version {process.env.REACT_APP_VERSION} - Please <Link to="/login" className="text-white text-decoration-underline fw-bold">Login</Link> to view your personalized resources!</p>
              </div>
            </div>
          </div>
        </header>
        <section className="py-5 bg-light">
          <div className="container">
            <Alert variant="warning" className="shadow-sm border-0 mb-5 fw-light">
              <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
              <strong>Ecosystem Notice:</strong> If you have access to the <strong>Personalized Cloud Dashboard (<abbr title="Personalized Cloud Dashboard">PCD</abbr>)</strong>, but are currently utilizing the standard <strong>Cloud Dashboard (<abbr title="Cloud Dashboard">CD</abbr>)</strong> interface, certain premium data synchronization features and advanced analytical modules will remain unused.
            </Alert>

            <div className="row">
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="card h-100 shadow-sm border-0 rounded-lg text-center p-4 d-flex flex-column">
                  <div className="text-warning mb-3 display-4 d-flex align-items-center justify-content-center">
                    <FontAwesomeIcon icon="mobile-alt" />
                    <img src={(process.env.PUBLIC_URL || '') + "/favicon-32x32.png?v=0.1.31"} alt="Android Icon" className="ms-2" style={{ width: '32px', height: '32px' }} />
                  </div>
                  <h5 className="font-weight-bold">HealthDash Mobile</h5>
                  <p className="small text-muted mb-2">Flagship Android application for real-time health tracking.</p>
                  <AndroidAppFlavours />
                  <a href={mobileAppLink} target="_blank" rel="noopener noreferrer" className="btn btn-outline-warning btn-sm mt-auto fw-bold">
                    {isMobileApp ? 'Open App' : 'Install App'}
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="card h-100 shadow-sm border-0 rounded-lg text-center p-4">
                  <div className="text-warning mb-3 display-4"><FontAwesomeIcon icon="cloud" /></div>
                  <h5 className="font-weight-bold">Cloud Dashboard (<abbr title="Personalized Cloud Dashboard">PCD</abbr>)</h5>
                  <p className="small text-muted">Personalized data synchronization and management portal.</p>
                  <Link to="/ecosystem/PCD" className="btn btn-outline-warning btn-sm mt-auto fw-bold">
                    Open <abbr title="Personalized Cloud Dashboard">PCD</abbr>
                  </Link>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="card h-100 shadow-sm border-0 rounded-lg text-center p-4">
                  <div className="text-warning mb-3 display-4"><FontAwesomeIcon icon="chart-bar" /></div>
                  <h5 className="font-weight-bold">Visualizer (<abbr title="Data Source Visualizer">DSV</abbr>)</h5>
                  <p className="small text-muted">Advanced visualization engine for cross-platform health metrics.</p>
                  <Link to="/ecosystem/DSV" className="btn btn-outline-warning btn-sm mt-auto fw-bold">
                    Open <abbr title="Data Source Visualizer">DSV</abbr>
                  </Link>
                </div>
              </div>
              {authState?.isAuthenticated && (
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="card h-100 shadow-sm border-0 rounded-lg text-center p-4">
                  <div className="text-danger mb-3 display-4"><FontAwesomeIcon icon="user-shield" /></div>
                  <h5 className="font-weight-bold">Admin Panel</h5>
                  <p className="small text-muted">Infrastructure management and system-level <abbr title="Personalized Cloud Dashboard">PCD</abbr> provisioning.</p>
                  <a href="https://pcd-12-dot-api-project-668384552013.ew.r.appspot.com" target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger btn-sm mt-auto fw-bold">
                    Open the Admin Panel
                  </a>
                </div>
              </div>
              )}
            </div>
          </div>
        </section>
      </>
  );
};

export default Dashboard;
